import { render, staticRenderFns } from "./AreaProdutiva2007Vn.vue?vue&type=template&id=e81a75c4&lang=pug"
import script from "./AreaProdutiva2007Vn.vue?vue&type=script&lang=js"
export * from "./AreaProdutiva2007Vn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports